import { readForumAttribute } from './helpers';
function isAdmin() {
  try {
    const u = app.session && app.session.user;
    return !!(u && typeof u.isAdmin === 'function' && u.isAdmin());
  } catch (e) {
    return false;
  }
}
export function canCreateSupportTicket() {
  try {
    if (!app.session || !app.session.user) return false;
    if (isAdmin()) return true;
    return !!readForumAttribute('canCreateSupportTicket');
  } catch (e) {
    return false;
  }
}
export function canHandleSupportTickets() {
  try {
    if (!app.session || !app.session.user) return false;
    if (isAdmin()) return true;
    return !!readForumAttribute('canHandleSupportTickets');
  } catch (e) {
    return false;
  }
}
export function supportAppealBanned() {
  try {
    return !!readForumAttribute('supportAppealBanned');
  } catch (e) {
    return false;
  }
}
export function isUserSuspended() {
  try {
    return !!readForumAttribute('supportSuspended');
  } catch (e) {
    return false;
  }
}
flarum.reg.add('linkrobins-support', 'forum/utils/permissions', { canCreateSupportTicket: canCreateSupportTicket,canHandleSupportTickets: canHandleSupportTickets,supportAppealBanned: supportAppealBanned,isUserSuspended: isUserSuspended, });